var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"18px"},domProps:{"innerHTML":_vm._s(_vm.pageData.inviteRule)}})
}
var staticRenderFns = []

export { render, staticRenderFns }